import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

export default {
  getById(id) {
    return http.get(`/preset-messages/${id}`).then(handleResponse);
  },

  getBycampaign(id) {
    return http.get(`/campaigns/whatsapp/${id}/preset-messages`);
  },

  getByQueue(id) {
    return http.get(`/queues/whatsapp/${id}/preset-messages`);
  },
};
